module.exports = __webpack_public_path__ + "img/173.442ab3c1.jpg";